export enum Language {
    EN = 'en',
    RU = 'ru',
    EL = 'el',
}

export enum Namespace {
    TRANSLATION = 'translation',
}
